// GENERATED FILE - DO NOT MODIFY
export enum ServiceQuotationContext {
    Service = "S",
    WorkOrder = "B",
}

export let nameof = "ServiceQuotationContext";
